/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolEmptyResponse,
  MonitoringFilterProtocolResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsApplyCustomTagRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsDeleteAllCustomTagRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCommentUserTypeFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountryFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCustomTagsFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetDomainStatusFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetHeaderCountDataResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusByTabRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusByTabResponse,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MonitoringWebsiteDomainNames<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameFilterCountryCreate
   * @request POST:/website/domain-name/filter/country
   */
  domainNameFilterCountryCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountryFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/domain-name/filter/country`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameFilterCommentUserTypeCreate
   * @request POST:/website/domain-name/filter/comment-user-type
   */
  domainNameFilterCommentUserTypeCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCommentUserTypeFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/domain-name/filter/comment-user-type`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameFilterCustomTagsCreate
   * @request POST:/website/domain-name/filter/custom-tags
   */
  domainNameFilterCustomTagsCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCustomTagsFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/domain-name/filter/custom-tags`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameFilterDomainStatusCreate
   * @request POST:/website/domain-name/filter/domain-status
   */
  domainNameFilterDomainStatusCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetDomainStatusFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/domain-name/filter/domain-status`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameHeaderList
   * @request GET:/website/domain-name/header
   */
  domainNameHeaderList = (params: RequestParams = {}) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetHeaderCountDataResponse, any>({
      path: `/website/domain-name/header`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameCountCreate
   * @request POST:/website/domain-name/count
   */
  domainNameCountCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountResponse, any>({
      path: `/website/domain-name/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameGetListCreate
   * @request POST:/website/domain-name/get-list
   */
  domainNameGetListCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListResponse, any>({
      path: `/website/domain-name/get-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameDetailsCreate
   * @request POST:/website/domain-name/details
   */
  domainNameDetailsCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailResponse, any>({
      path: `/website/domain-name/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameReportedDetailsCreate
   * @request POST:/website/domain-name/reported/details
   */
  domainNameReportedDetailsCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailResponse, any>({
      path: `/website/domain-name/reported/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameExcelCreate
   * @request POST:/website/domain-name/excel
   */
  domainNameExcelCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsResponse, any>({
      path: `/website/domain-name/excel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameStatusUpdateCreate
   * @request POST:/website/domain-name/status/update
   */
  domainNameStatusUpdateCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusResponse, any>({
      path: `/website/domain-name/status/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameStatusTabUpdateCreate
   * @request POST:/website/domain-name/status/tab/update
   */
  domainNameStatusTabUpdateCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusByTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusByTabResponse, any>({
      path: `/website/domain-name/status/tab/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameAuthorizedCreate
   * @request POST:/website/domain-name/authorized
   */
  domainNameAuthorizedCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedResponse, any>({
      path: `/website/domain-name/authorized`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameCustomTagApplyCreate
   * @request POST:/website/domain-name/custom-tag/apply
   */
  domainNameCustomTagApplyCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsApplyCustomTagRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/website/domain-name/custom-tag/apply`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteDomainNames
   * @name DomainNameCustomTagDeleteAllCreate
   * @request POST:/website/domain-name/custom-tag/delete-all
   */
  domainNameCustomTagDeleteAllCreate = (
    data: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsDeleteAllCustomTagRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/website/domain-name/custom-tag/delete-all`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
